<template>
  <div>
      <v-dialog
      v-model="dialog"
      max-width="300"
    >
      <v-card>
        <v-list>
          <v-list-tile
            avatar
          >
            <v-list-tile-avatar
              class="headline font-weight-light white--text"
            >
              <span class="secondary--text" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 50%; width: 40px; height: 40px; line-height: 40px;">{{report.sender_name.charAt(0)}}</span>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ report.sender_name }} says, </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-card-text v-text="report.message"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="pa-2 white">
      <p class="mb-0 text-xs-center">
        <span class="caption">Here are your stats for</span> {{report.start_date | calendarShortUnix}} - {{report.end_date | calendarShortUnix}}
      </p>
    </div>
    <statistics :user="userProfile" :report="report"></statistics>
    <div class="pa-2">
      <v-btn block @click="dialog = true" color="primary" outline>View coaches comments</v-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import statistics from '@/components/partial/statistics.vue'
export default {
  components: {
    statistics
  },
  data () {
    return {
      dialog: true,
      report: this.$route.params.report
    }
  },
  mounted () {
  },
  methods: {
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    })
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/members/reportShowView.vue